module.exports = __webpack_public_path__ + "static/media/Logo__CodePath.a9ee80bb.svg";